import { z } from 'zod';

export const ProductPublishStatusFilterSchema = z.enum(['all', 'unpublished']);
export type ProductPublishStatusFilter = z.infer<
  typeof ProductPublishStatusFilterSchema
>;

export const ProductTableFilterSchema = z.object({
  freeText: z.string().optional(),
  publishStatus: ProductPublishStatusFilterSchema.catch('all').default('all'),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
});
